import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ApplicationApi } from '@classes/application/application';
import { ClientSmartHub } from '@classes/client/client';
import { RoleApi } from '@classes/role/role';
import { AddUser, Client } from '@classes/user/userAdd';
import {
  faInfoCircle,
  faPlus,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { ApplicationService } from '@services/application/application.service';
import { ClientService } from '@services/client/client.service';
import { RolesService } from '@services/roles/roles.service';
import { UiService } from '@services/ui/ui.service';
import { UserService } from '@services/user/user.service';

export interface DialogData {
  client: ClientSmartHub;
}

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.scss'],
})
export class AddUsersComponent implements OnInit {
  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faInfo = faInfoCircle;

  addUserForm: UntypedFormGroup;
  inactive = true;
  ArrayValueInput: string[] = [];
  confirmAdd = false;
  clients: ClientSmartHub[];
  applications: ApplicationApi[];
  roles: RoleApi[];
  appChoice: string[] = [];
  applicationsFiltered: ApplicationApi[];
  client: ClientSmartHub;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    private userService: UserService,
    private clientService: ClientService,
    private applicationService: ApplicationService,
    private roleService: RolesService,
    private uiService: UiService,
    public dialogRef: MatDialogRef<AddUsersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.getAllClients();
    this.getAllApplications();
    this.getAllRoles();
    this.getClientName();
    this.initForm();
  }

  onSubmit(): void {
    const client = this.clients.find((c) => c.name === this.f.client.value);

    const newUser: AddUser = {
      username: this.f.username.value,
      email: this.f.email.value,
      gsm: this.f.gsm.value,
      client: client,
      applications: this.f.applications.value,
    };

    this.userService.addUser(newUser).subscribe({
      next: () => this.dialog.closeAll(),
    });
  }

  isInactive(): void {}

  getData(isNew: boolean) {
    return {
      isNew,
    };
  }

  addApplicationInput(): void {
    this.applicationControls.controls?.length < this.applications?.length
      ? this.applicationControls.push(this.createApplicationInput())
      : this.uiService.showSnackbar(
          "Vous ne pouvez plus ajouter d'application"
        );
  }

  deleteApplicationInput(index: number): void {
    this.applicationControls.removeAt(index);
  }

  filterValuesApp(index: number, app?: string): boolean {
    const appPrevious = [];

    for (let i = index; i > 0; i--) {
      const appName = this.getApplicationControlsInput(i - 1)?.value;
      appPrevious.push(appName);
    }

    return appPrevious.includes(app) ? false : true;
  }

  get f() {
    return this.addUserForm.controls;
  }

  get applicationControls(): UntypedFormArray {
    return this.addUserForm.controls.applications as UntypedFormArray;
  }
  getApplicationControlsInput(index: number): UntypedFormGroup {
    return this.applicationControls.controls[index]['controls']
      .applicationName as UntypedFormGroup;
  }

  private getClientName(): void {
    this.userService.getCurrentUser().subscribe({
      next: (user) => {
        this.client = user.client;
        this.addUserForm.get('client').setValue(this.client?.name);
      },
    });
  }

  private getAllClients(): void {
    this.clientService.getAllClients().subscribe({
      next: (clients) => (this.clients = clients),
    });
  }
  private getAllApplications(): void {
    this.applicationService.getAllApplications().subscribe({
      next: (applications) => {
        this.applications = applications;
        this.applicationsFiltered = applications;
      },
    });
  }
  private getAllRoles(): void {
    this.roleService.getAllRole().subscribe({
      next: (roles) => (this.roles = roles),
    });
  }

  private initForm(): void {
    this.addUserForm = this.formBuilder.group({
      username: ['', Validators.required],
      email: ['', Validators.required],
      gsm: [''],
      client: [this.client?.name, [Validators.required]],
      applications: this.formBuilder.array([], Validators.required),
    });
  }

  private createApplicationInput(): UntypedFormGroup {
    let group = this.formBuilder.group({
      application: ['', Validators.required],
      role: ['', Validators.required],
    });

    group.get('application').valueChanges.subscribe((result) => {
      if (result) {
        group.get('role').reset();
      }
    });

    return group;
  }
}
